import { render, staticRenderFns } from "./FreightAdd.vue?vue&type=template&id=55ba6a8a&scoped=true"
import script from "./FreightAdd.vue?vue&type=script&lang=js"
export * from "./FreightAdd.vue?vue&type=script&lang=js"
import style0 from "./FreightAdd.vue?vue&type=style&index=0&id=55ba6a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba6a8a",
  null
  
)

export default component.exports